import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CroRegistrationDataService } from './cro-registration-data.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    { provide: CroRegistrationDataService, useClass: CroRegistrationDataService, multi: false }
  ]
})
export class CroRegistrationDataModule { }
